// import {} from "@react-spectrum/s2";
import { useNavigate } from "react-router";
import {
  ActionButtonGroup,
  ActionButton,
  Text,
  Badge,
  LinkButton,
  MenuTrigger,
  Menu,
  MenuItem,
} from "@react-spectrum/s2";
import { UserMenu } from "@app/components/UserMenu";
import { useIsAdmin } from "@app/hooks/useRoles";
import ChatIcon from "@react-spectrum/s2/icons/Chat";
import RocketQuickActionsIcon from "@react-spectrum/s2/icons/RocketQuickActions";
import MenuHamburgerIcon from "@react-spectrum/s2/icons/MenuHamburger";

import { style } from "@react-spectrum/s2/style" with { type: "macro" };

export const MobileHeader = ({ styles }) => {
  const navigate = useNavigate();

  const isAdmin = useIsAdmin();

  return (
    <header
      className={
        styles +
        style({
          display: {
            default: "flex",
            lg: "none",
          },
          alignItems: "center",
          gap: 8,
          paddingY: 8,
          paddingX: 8,
        })
      }
    >
      <ActionButtonGroup isQuiet>
        <MenuTrigger>
          <ActionButton>
            <MenuHamburgerIcon />
          </ActionButton>
          <Menu>
            <MenuItem onPress={() => navigate("/")}>Home</MenuItem>
            <MenuItem onPress={() => navigate("/projects")}>Projects</MenuItem>
            {isAdmin && (
              <MenuItem onPress={() => navigate("/admin")}>Admin</MenuItem>
            )}
          </Menu>
        </MenuTrigger>
        <ActionButton onPress={() => navigate("/")}>
          <Text
            styles={style({
              font: "title-sm",
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              marginEnd: -4,
            })}
          >
            BeStory
            <Badge
              size="XS"
              variant="magenta"
              UNSAFE_style={{ paddingInline: 2 }}
            >
              <RocketQuickActionsIcon />
            </Badge>
          </Text>
        </ActionButton>
      </ActionButtonGroup>
      <div
        id="beStory-mobile-header-content"
        className={style({ flexGrow: 1, display: "flex", gap: 24 })}
      />
      <div
        className={style({
          display: "flex",
          alignItems: "center",
          gap: 12,
          marginStart: "auto",
        })}
      >
        <LinkButton
          aria-label="Slack community"
          href="slack://channel?team=E23RE8G4F&id=C095CSV0N0Z"
          target="_blank"
          variant="secondary"
        >
          <ChatIcon />
        </LinkButton>
        <UserMenu />
      </div>
    </header>
  );
};
